
import OrganismPageLoader from '~/components/organisms/common/OrganismPageLoader.vue'

export default {
  name: 'DefaultLayout',
  components: { OrganismPageLoader }
}
